/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Summer_Focus_Content_ExtendInputs */

const en_dialog_summer_focus_content_extend = /** @type {(inputs: Dialog_Summer_Focus_Content_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The focus accumulation period has been extended to Sep 9, 08:00 (UTC+8).`)
};

const ar_dialog_summer_focus_content_extend = /** @type {(inputs: Dialog_Summer_Focus_Content_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم تمديد فترة التركيز حتى 9 سبتمبر، الساعة 08:00 (UTC+8).`)
};

const de_dialog_summer_focus_content_extend = /** @type {(inputs: Dialog_Summer_Focus_Content_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Fokus-Zeitraum wurde bis zum 9. September, 08:00 Uhr (UTC+8), verlängert.`)
};

const es_dialog_summer_focus_content_extend = /** @type {(inputs: Dialog_Summer_Focus_Content_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El período de concentración se ha extendido hasta el 9 de septiembre a las 08:00 (UTC+8).`)
};

const fr_dialog_summer_focus_content_extend = /** @type {(inputs: Dialog_Summer_Focus_Content_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La période de concentration a été prolongée jusqu’au 9 septembre à 08 h 00 (UTC+8).`)
};

const it_dialog_summer_focus_content_extend = /** @type {(inputs: Dialog_Summer_Focus_Content_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il periodo di concentrazione è stato prolungato fino al 9 settembre alle 08:00 (UTC+8).`)
};

const ja_dialog_summer_focus_content_extend = /** @type {(inputs: Dialog_Summer_Focus_Content_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中期間が9月9日08:00（UTC+8）まで延長されました。`)
};

const ko_dialog_summer_focus_content_extend = /** @type {(inputs: Dialog_Summer_Focus_Content_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 기간이 9월 9일 08:00(UTC+8)까지 연장되었습니다.`)
};

const pt_br_dialog_summer_focus_content_extend = /** @type {(inputs: Dialog_Summer_Focus_Content_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O período de foco foi prorrogado até 9 de setembro, às 08:00 (UTC+8).`)
};

const ru_dialog_summer_focus_content_extend = /** @type {(inputs: Dialog_Summer_Focus_Content_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Период концентрации продлён до 9 сентября, 08:00 (UTC+8).`)
};

const th_dialog_summer_focus_content_extend = /** @type {(inputs: Dialog_Summer_Focus_Content_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ช่วงเวลาโฟกัสขยายถึงวันที่ 9 ก.ย. เวลา 08:00 น. (UTC+8)`)
};

const tr_dialog_summer_focus_content_extend = /** @type {(inputs: Dialog_Summer_Focus_Content_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanma Dönemi 9 Eylül 08:00'a (UTC+8) kadar uzatıldı.`)
};

const zh_cn_dialog_summer_focus_content_extend = /** @type {(inputs: Dialog_Summer_Focus_Content_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专注时长累积期间已延长至 9 月 9 日 08:00（UTC+8）。`)
};

const zh_tw_dialog_summer_focus_content_extend = /** @type {(inputs: Dialog_Summer_Focus_Content_ExtendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專注累積期間已延長至 9 月 9 日 08:00（UTC+8）。`)
};

/**
* | output |
* | --- |
* | "The focus accumulation period has been extended to Sep 9, 08:00 (UTC+8)." |
*
* @param {Dialog_Summer_Focus_Content_ExtendInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_summer_focus_content_extend = /** @type {((inputs?: Dialog_Summer_Focus_Content_ExtendInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Summer_Focus_Content_ExtendInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_summer_focus_content_extend(inputs)
	if (locale === "ar") return ar_dialog_summer_focus_content_extend(inputs)
	if (locale === "de") return de_dialog_summer_focus_content_extend(inputs)
	if (locale === "es") return es_dialog_summer_focus_content_extend(inputs)
	if (locale === "fr") return fr_dialog_summer_focus_content_extend(inputs)
	if (locale === "it") return it_dialog_summer_focus_content_extend(inputs)
	if (locale === "ja") return ja_dialog_summer_focus_content_extend(inputs)
	if (locale === "ko") return ko_dialog_summer_focus_content_extend(inputs)
	if (locale === "pt_br") return pt_br_dialog_summer_focus_content_extend(inputs)
	if (locale === "ru") return ru_dialog_summer_focus_content_extend(inputs)
	if (locale === "th") return th_dialog_summer_focus_content_extend(inputs)
	if (locale === "tr") return tr_dialog_summer_focus_content_extend(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_summer_focus_content_extend(inputs)
	return zh_tw_dialog_summer_focus_content_extend(inputs)
});